import { logEvent } from '../../lib/analytics';
import { redirectToOnboardingCheckout } from '../../lib/redirect';

interface StickyFooterVoiceCardProps {
  voiceId: string;
  languageCode: string;
  testVariant: string;
}

export const StickyFooterVoiceCard = ({
  voiceId,
  languageCode,
  testVariant,
}: StickyFooterVoiceCardProps) => {
  const handleClick = () => {
    logEvent('more_voices_clicked', {
      current_voice: voiceId,
      language: languageCode,
      test_variant: testVariant,
    });
    redirectToOnboardingCheckout({
      voiceId: voiceId,
      destination: 'scratchpad',
      showVoiceList: true
    });
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className="group relative flex w-full cursor-pointer items-center justify-center gap-2 rounded-2xl border-0 px-3 py-[6px] outline-none duration-300 hover:scale-[1.02]"
      style={{
        backgroundImage: 'linear-gradient(to right, #9333ea, #2563eb)',
        boxShadow: '0 4px 12px rgba(139, 92, 246, 0.3)',
      }}>
      <span className="text-lg">✨</span>
      <div className="text-md flex items-center whitespace-nowrap font-semibold text-white">
        Explore 1000+ Voices
      </div>
    </button>
  );
};
